import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-02-22'
        tag='Kidizen'
        title='Kidizen Sharing (Bumping) Items to Boost Your Sales'
      >
        <p>
          Finding ways to level up your online business is always an evolving process. Many online sellers nowadays are
          getting creative to reach as many buyers as possible to ensure that their items are coming across buyers who
          might be interested in their listing, which will ultimately result in conversions. But before getting creative
          outside the marketplace of your choice, it is always best to maximize the potential of the tools and features
          provided by the marketplace where you sell.
        </p>
        <p>
          Like many popular online shopping platforms like Poshmark, Mercari, eBay, and Depop, Kidizen has features to
          help sellers reach a broader range of potential buyers.{' '}
        </p>
        <p>
          Because one of the most critical keys in selling on marketplaces is making your item visible to the feeds of
          users, followers, and search engines. Features such as Promoted Listings and Bumping items are very helpful,
          and Kidizen encourages its users to utilize their sharing feature.{' '}
        </p>
        <p>
          In this blog post, let's talk about what Bumping items on Kidizen are and how it works to give you an
          advantage in selling.
        </p>

        <h3>What is Kidizen</h3>
        <p>
          Kidizen is an online resale marketplace where parents usually shop for fashion items and essentials at
          affordable prices. The platform advocates providing a marketplace for moms where they can earn and find the
          best styles for their kids. It has a parent-to-parent community that encourages connections between moms to
          share not only their style but also their experiences.{' '}
        </p>
        <p>
          The idea of reselling kids' clothes and essentials comes from the fact that kids easily outgrow their things
          resulting in piles of unused items. And to practice responsible consumption, Kidizen became a venue for these
          treasures.
        </p>
        <p>
          Like in other marketplaces, sellers on Kidizen have equal opportunities to generate income at the comfort of
          their homes. You can buy and sell clothes, shoes, accessories, nursery and room decor, toys, books, and more,
          including stylish maternity clothes, essential baby items like baby carriers, diaper bags, and other items for
          newborns.
        </p>

        <h3>Sharing or Bumping Items on Kidizen</h3>
        <p>
          Bumping or sharing items on Kidizen lets sellers get their listings in front of more shoppers. The more you
          share, the higher the chance that other users will see your listings, boosting your sales.{' '}
        </p>
        <p>
          When you bump your items, they appear on top of the shop feed. Remember that there are a lot of sellers like
          you on the platform that lists tons of items every minute; hence the competition can be tough. Keeping your
          listings afloat and not drowned by newly posted and shared items can be challenging, so you must ensure their
          presence where many users can see them. When you share your items, your followers get notified to check the
          listings that you shared.{' '}
        </p>
        <p>To share your listings:</p>
        <ol>
          <li> Locate the Share button on the lower right-hand area of your listing photo</li>
          <li> Choose to share with your followers inside Kidizen or other networks</li>
        </ol>

        <h3>Stay connected with other users.</h3>
        <p>
          Sharing items on Kidizen isn't exclusive to your listings. You may also share other people's items which can
          earn you your own shares. This is how the community is connected on the platform. It allows all the users to
          interact by asking and answering questions in the comment section. Sharing also serves as the ideal venue for
          shops to tend to inquiries efficiently without worrying about losing conversations.
        </p>
        <p>
          In addition to this, you will get notifications when others have shared your items. To get notified, here's
          how you can set your preference.
        </p>
        <ol>
          <li>Go to your profile setting by clicking the Me button</li>
          <li>Click on the Gear Icon located below your profile</li>
          <li>
            Choose your desired Push and In-App Notifications for the following:
            <ul>
              <li> Sales & Purchases</li>
              <li> Shared Listings</li>
              <li> Social Activity</li>
              <li> Items in your shop being carted</li>
              <li> Discounts.</li>
            </ul>
          </li>
          <li>Lastly, set your desired Email Notifications tool.</li>
        </ol>

        <p>
          You could also easily see who has shared your listing by taping the shared tally below your listing's
          description. This feature can only be visible once someone has shared the item.
        </p>
        <p>
          <strong>Note:</strong> Each seller can only share one listing per hour. Kidizen has implemented this limit to
          keep the shop feed organized and uncluttered.
        </p>

        <h3>Automation That Boosts Your Sales</h3>
        <p>
          Now that you have learned what Bumping items on Kidizen can do, it's high time that you use it to its full
          potential to increase your conversions. Keep sharing and bumping so your listings can come across its right
          buyer!{' '}
        </p>
        <p>
          To improve your sales and increase your income, selling on other marketplaces like Poshmark, Mercari, Depop,
          eBay, and more can also give you an advantage. While listing on these platforms sounds tiring, an automation
          tool like OneShop can make your seller's life easy.{' '}
        </p>
        <p>
          If you're selling on these platforms, too, OneShop can help you automate important activities to keep your
          closet active while giving you lots of time to do other things that help grow your business. Cross-listing is
          also a breeze as you will only have to draft once, and OneShop will take care of cross-posting your item to
          other marketplaces you have linked in our app.
        </p>
        <p>
          If you're ready to level up your business and experience how it is to have more time at hand while ensuring
          that your closet is performing, all you have to do is sign up{' '}
          <a href='https://tools.oneshop.com/signup'>here</a>, and we'll text you the link to the app.{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
